import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getDetailedInfo } from '../utils/interpreter';
import './Details.css';

const Details = () => {
  const { type } = useParams();
  const navigate = useNavigate();
  const [details, setDetails] = useState(null);

  useEffect(() => {
    // 从localStorage获取你的依恋风格
    const resultsData = localStorage.getItem(`attachment_test_${type}_results`);

    if (resultsData) {
      const parsedResults = JSON.parse(resultsData);
      const detailedInfo = getDetailedInfo(parsedResults.attachmentStyle);
      setDetails(detailedInfo);
    } else {
      navigate('/');
    }
  }, [type, navigate]);

  const goToHome = () => {
    navigate('/');
  };

  if (!details) {
    return <div className="loading">加载详细分析中...</div>;
  }

  return (
    <div className="details-container">
      <div className="page-container">
        <div className="page-header">
          <h1 className="page-title">详细分析报告</h1>
          <p className="page-subtitle">深度了解你的依恋风格</p>
        </div>

        <div className="page-content">
          {/* 性格特征 */}
          <div className="analysis-section">
            <h2 className="section-title">性格特征</h2>
            <ul className="characteristics-list">
              {details.characteristics.map((trait, index) => (
                <li key={index} className="characteristic-item">{trait}</li>
              ))}
            </ul>
          </div>

          {/* 维度分析 */}
          <div className="analysis-section">
            <h2 className="section-title">焦虑维度分析</h2>
            {Array.isArray(details.anxietyAnalysis) ? (
              details.anxietyAnalysis.map((paragraph, index) => (
                <p key={index} className="analysis-text">{paragraph}</p>
              ))
            ) : (
              <p className="analysis-text">{details.anxietyAnalysis}</p>
            )}
          </div>

          <div className="analysis-section">
            <h2 className="section-title">回避维度分析</h2>
            {Array.isArray(details.avoidanceAnalysis) ? (
              details.avoidanceAnalysis.map((paragraph, index) => (
                <p key={index} className="analysis-text">{paragraph}</p>
              ))
            ) : (
              <p className="analysis-text">{details.avoidanceAnalysis}</p>
            )}
          </div>

          {/* 关系模式 */}
          <div className="analysis-section">
            <h2 className="section-title">关系模式</h2>
            {Array.isArray(details.relationshipPattern) ? (
              details.relationshipPattern.map((paragraph, index) => (
                <p key={index} className="analysis-text">{paragraph}</p>
              ))
            ) : (
              <p className="analysis-text">{details.relationshipPattern}</p>
            )}
          </div>

          {/* 详细建议 */}
          <div className="analysis-section">
            <h2 className="section-title">改善建议</h2>
            <ul className="suggestions-list">
              {details.detailedSuggestions.map((suggestion, index) => (
                <li key={index} className="suggestion-item">{suggestion}</li>
              ))}
            </ul>
          </div>

          {/* 操作按钮 */}
          <div className="details-actions">
            <button className="btn btn-primary" onClick={goToHome}>
              返回首页
            </button>
          </div>

          {/* 底部免责声明和版权信息 */}
          <div className="footer-disclaimer">
            <p className="footer-disclaimer-text">
              本测试仅供参考，不能替代专业心理咨询。<br />
              如有严重情绪问题，请及时寻求专业帮助。
            </p>
            <p className="footer-copyright">
              © 2024 依恋型人格测试 | 基于科学心理学理论
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Details;
